import React, { useState } from 'react';

function DetailModal({ isOpen, onClose, topic }) {
  const [activeTab, setActiveTab] = useState('details');

  console.log(topic);

  const getBarColor = (score) => {
    if (score < 0.5) {
      return `rgb(${255}, ${Math.floor(255 * score * 2)}, 0)`; // Red to Yellow
    } else {
      return `rgb(${Math.floor(255 * (1 - score) * 2)}, 255, 0)`; // Yellow to Green
    }
  };

  if (!isOpen || !topic) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
      <div className="bg-black px-4 py-4 border-2 border-neutral-800 rounded-lg shadow-lg w-screen m-8" style={{ height: 'calc(100vh - 2rem)' }}>
        <div>
          <div className="relative flex justify-between items-center mb-2">
            <div className="flex items-center text-center mx-auto">
              <h2 className="text-3xl font-bold text-center mx-auto py-2">{topic.currentSurvey.topicName}</h2>
            </div>
            <div className="self-end">
              <button onClick={onClose} className="absolute top-0 right-0 text-red-500 mr-2 text-3xl">✕</button>
            </div>
          </div>
          <div>
              <div className="flex justify-between mb-2">
              <button
                className={`block w-full px-4 py-2 border-b-4 border-neutral-500 ${activeTab === 'details' ? 'border-b-2 border-sky-500 font-bold' : ''}`}
                onClick={() => setActiveTab('details')}
              >
                Details
              </button>
              <button
                className={`block w-full px-4 py-2 border-b-4 border-neutral-500 ${activeTab === 'comments' ? 'border-b-2 border-sky-500 font-bold' : ''}`}
                onClick={() => setActiveTab('comments')}
              >
                Comments
              </button>
            </div>
          </div>
        </div>
        <div className="p-4 pb-16 overflow-y-auto" style={{
          maxHeight: 'calc(90vh - 4rem)', // Adjust based on header height
        }}>
        {activeTab === 'details' && (
          <div>
            <h2 className="text-xl font-semibold mb-4 text-center">Survey Details</h2>
            <table className="mb-4 w-full">
              <tbody>
                <tr>
                  <td className="font-semibold w-1/6 text-center">Priority</td>
                  <td className="font-semibold w-1/6 text-center">Votes</td>
                  <td className="font-semibold w-1/6 text-center">Rank</td>
                  <td className="font-semibold w-1/6 text-center">Sentiment</td>
                  <td className="font-semibold w-1/6 text-center">Average Score</td>
                  <td className="font-semibold w-1/6 text-center">Standard Deviation</td>
                </tr>
                <tr>
                  <td className="text-center text-xl">
                    {topic.currentSurvey.focusRank === null ? 'NR' : '#'+topic.currentSurvey.focusRank}
                    {topic.currentSurvey.focusRankChange === null || topic.currentSurvey.focusRankChange === 0 ? (
                      <span className="text-neutral-500 ml-2 text-base">-</span>
                    ) : topic.currentSurvey.focusRankChange > 0 ? (
                      <span className="text-green-500 ml-2 text-base">↑{topic.currentSurvey.focusRankChange}</span>
                    ) : (
                      <span className="text-red-500 ml-2 text-base">↓{Math.abs(topic.currentSurvey.focusRankChange)}</span>
                    )}
                  </td>
                  <td className="text-center text-xl">{topic.currentSurvey.focusCount}</td>
                  <td className="text-center text-xl">
                    #{topic.currentSurvey.rank}
                    {topic.currentSurvey.rankChange === null || topic.currentSurvey.rankChange === 0 ? (
                      <span className="text-neutral-500 ml-2 text-base">-</span>
                    ) : topic.currentSurvey.rankChange > 0 ? (
                      <span className="text-green-500 ml-2 text-base">↑{topic.currentSurvey.rankChange}</span>
                    ) : (
                      <span className="text-red-500 ml-2 text-base">↓{Math.abs(topic.currentSurvey.rankChange)}</span>
                    )}
                  </td>
                  <td className="text-center text-xl" style={{color: getBarColor(topic.currentSurvey.score)}}>{(topic.currentSurvey.score * 100).toFixed(0)}%</td>
                  <td className="text-center text-xl">{topic.currentSurvey.average.toFixed(2)}</td>
                  <td className="text-center text-xl">{topic.currentSurvey.standardDeviation.toFixed(2)}</td>
                </tr>
              </tbody>
            </table>
            <h2 className="text-xl font-semibold mb-4 mt-12 pt-2 text-center">Distribution</h2>
            <div className="flex flex-col items-center justify-center">
                <div className="flex items-center">
                    <div className="w-28 text-right mr-2">Positive:</div>
                    <div className="relative w-24 h-2 bg-neutral-700 rounded">
                    <div
                        className="absolute top-0 left-0 h-2 rounded bg-green-500"
                        style={{
                        width: `${(topic.currentSurvey.distribution.positive/topic.currentSurvey.distribution.total * 100).toFixed(2)}%`,
                        }}
                    ></div>
                    </div>
                    <div className="ml-2 text-sm w-12">
                        {(topic.currentSurvey.distribution.positive/topic.currentSurvey.distribution.total * 100).toFixed(0)}%
                    </div>
                </div>
                <div className="flex items-center">
                <div className="w-28 text-right mr-2">Neutral:</div>
                    <div className="relative w-24 h-2 bg-neutral-700 rounded">
                    <div
                        className="absolute top-0 left-0 h-2 rounded bg-yellow-500"
                        style={{
                        width: `${(topic.currentSurvey.distribution.neutral/topic.currentSurvey.distribution.total * 100).toFixed(2)}%`,
                        }}
                    ></div>
                    </div>
                    <div className="ml-2 text-sm w-12">
                        {(topic.currentSurvey.distribution.neutral/topic.currentSurvey.distribution.total * 100).toFixed(0)}%
                    </div>
                </div>
                <div className="flex items-center">
                <div className="w-28 text-right mr-2">Negative:</div>
                    <div className="relative w-24 h-2 bg-neutral-700 rounded">
                        
                    <div
                        className="absolute top-0 left-0 h-2 rounded bg-red-500"
                        style={{
                        width: `${(topic.currentSurvey.distribution.negative/topic.currentSurvey.distribution.total * 100).toFixed(2)}%`,
                        }}
                    ></div>
                    </div>
                    <div className="ml-2 text-sm w-12">
                        {(topic.currentSurvey.distribution.negative/topic.currentSurvey.distribution.total * 100).toFixed(0)}%
                    </div>
                </div>
            </div>
            <h2 className="text-xl font-semibold mb-4 mt-12 pt-2 text-center">Team Data</h2>
            <div className="overflow-x-auto">
              <table className="min-w-full text-sm">
                <thead>
                  <tr>
                    <th className="py-2 px-4 border-b-2 border-neutral-700 text-left"></th>
                    <th className="w-32 py-2 px-4 border-b-2 border-neutral-700 text-center">Priority</th>
                    <th className="w-32 py-2 px-4 border-b-2 border-neutral-700 text-center">Votes</th>
                    <th className="w-32 py-2 px-4 border-b-2 border-neutral-700 text-center">Rank</th>
                    <th className="w-32 py-2 px-4 border-b-2 border-neutral-700 text-center">Sentiment</th>
                    <th className="w-32 py-2 px-4 border-b-2 border-neutral-700 text-center">Avg Score</th>
                    <th className="w-32 py-2 px-4 border-b-2 border-neutral-700 text-center">Std Dev</th>
                    <th className="w-32 py-2 px-4 border-b-2 border-neutral-700 text-center">Sample Size</th>
                  </tr>
                </thead>
                <tbody>
                  {topic.currentSurvey.topicDataByTeam.map((team) => (
                    <tr key={team.teamId}>
                      <td className="py-2 px-4 border-b border-neutral-700 font-bold">{team.teamName}</td>
                      {team.answers ? (
                        <>
                          <td className="w-32 py-2 px-4 border-b border-neutral-700 text-center">
                            {team.answers.focusRank === null ? 'NR' : `#${team.answers.focusRank}`}
                            {team.answers.focusRankChange === null || team.answers.focusRankChange === 0 ? (
                                <span className="text-neutral-500 ml-2">-</span>
                            ) : team.answers.focusRankChange > 0 ? (
                                <span className="text-green-500 ml-2">↑{team.answers.focusRankChange}</span>
                            ) : (
                                <span className="text-red-500 ml-2">↓{Math.abs(team.answers.focusRankChange)}</span>
                            )}
                          </td>
                          <td className="w-32 py-2 px-4 border-b border-neutral-700 text-center">
                            {team.answers.focusCount}
                          </td>
                          <td className="w-32 py-2 px-4 border-b border-neutral-700 text-center">
                            <span className="mr-2">#{team.answers.rank}</span>
                            {team.answers.rankChange === null || team.answers.rankChange === 0 ? (
                                '-'
                            ) : team.answers.rankChange > 0 ? (
                                <span className="text-green-500">↑{team.answers.rankChange}</span>
                            ) : (
                                <span className="text-red-500">↓{Math.abs(team.answers.rankChange)}</span>
                            )}
                           </td>
                          <td className="w-32 py-2 px-4 border-b border-neutral-700 text-center" style={{
                            color: getBarColor(team.answers.score)
                          }}>
                            {(team.answers.score * 100).toFixed(0)}%
                          </td>
                          <td className="w-32 py-2 px-4 border-b border-neutral-700 text-center">{team.answers.average.toFixed(2)}</td>
                          <td className="w-32 py-2 px-4 border-b border-neutral-700 text-center">{team.answers.standardDeviation.toFixed(2)}</td>
                          <td className="w-32 py-2 px-4 border-b border-neutral-700 text-center">{team.answers.count}</td>
                        </>
                      ) : (
                        <>
                            <td colSpan="5" className="py-2 px-4 border-b border-neutral-700 text-center">No data available</td>
                            <td className="w-32 py-2 px-4 border-b border-neutral-700 text-center">0</td>
                        </>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
        {activeTab === 'comments' && (
          <div>
            <h2 className="text-xl font-bold mb-4 text-center">Comments</h2>
            {Array.isArray(topic.currentSurvey.freeTextJson) && topic.currentSurvey.freeTextJson.length > 0 ? (
                <ul className="list-none">
                {topic.currentSurvey.freeTextJson.map((comment, index) => (
                    <li key={index} className="p-4 mb-4 bg-neutral-900 border border-neutral-800 rounded-md">
                        <blockquote className="mb-2">
                            "{comment.freeText}"
                        </blockquote>
                        <p className="pt-2 font-semibold">{comment.user.name}</p>
                        {comment.user.teams && comment.user.teams.length > 0 && (
                            <p className="text-sm text-neutral-400">
                            {comment.user.teams.map(team => team.name).join(', ')}
                            </p>
                        )}
                    </li>
                ))}
                </ul>
            ) : (
                <p className="text-center pt-4">No comments on this topic</p>
            )}
            </div>
        )}
      </div>
      </div>
    </div>
  );
}

export default DetailModal;
